/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

// Parser korzysta tylko z gotowych tras indeksu, nigdy nie konstruuje nazwy analizy.
function pewniakiSearchIntent(query, config, routes) {
    if (!config || !Array.isArray(routes)) return null;
    if (/-\d|\d[.,]\d/.test(query)) return null;
    function normal(value) { return String(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l').replace(/-/g, ' '); }
    var text = ' ' + normal(query).trim() + ' ';
    if (/[<>]|https?:|\d{4}[-/.]\d/.test(text) || (config.reject || []).some(function (s) { return text.includes(' ' + normal(s) + ' '); })) return null;
    function matches(map) { return Object.keys(map).filter(function (key) { return map[key].some(function (alias) { return text.includes(' ' + normal(alias) + ' '); }); }); }
    var games = matches(config.games || {}), analyses = matches(config.analyses || {});
    // Lotto jest czescia Mini Lotto/Lotto Plus; dluzsza rozpoznana nazwa wygrywa.
    if (games.includes('mini-lotto') || games.includes('lotto-plus')) games = games.filter(function (g) { return g !== 'lotto'; });
    if (games.length !== 1 || analyses.length !== 1) return null;
    var numbers = text.match(/\b\d+\b/g) || [], all = (config.all || []).some(function (s) { return text.includes(' ' + normal(s) + ' '); });
    if ((all && numbers.length) || (!all && numbers.length !== 1)) return null;
    var size = all ? 'all' : Number(numbers[0]);
    if (!all && (!Number.isInteger(size) || size < 1 || size > 500 || !(config.range || []).some(function (s) { return text.includes(' ' + normal(s) + ' '); }))) return null;
    var found = routes.filter(function (r) { return r.game === games[0] && r.analysis === analyses[0]; });
    if (found.length !== 1 || !/^\/(?!\/)[^\s<>\\?#]*$/.test(found[0].url)) return null;
    return {title: found[0].title, desc: config.description.replace('%1', String(size === 'all' ? config.allLabel : size)), type: config.type, url: found[0].url + '?okno=' + size};
}
if (typeof module === 'object' && module.exports) module.exports = pewniakiSearchIntent;

(function () {
    'use strict';
    if (typeof document === 'undefined') return;
    function enText(pl, en) { return /^en(?:-|$)/i.test(document.documentElement.lang || '') ? en : pl; }
    var lang=/^en(?:-|$)/i.test(document.documentElement.lang||'')?'en':'pl';
    var root=document.querySelector('[data-site-search]');if(!root)return;
    var input=root.querySelector('[data-search-input]'),status=root.querySelector('[data-search-status]'),list=root.querySelector('[data-search-results]');
    var pending=null,seq=0,timer;
    function pokazPodpowiedzi() { root.classList.toggle('szukaj-serwis--otwarta', !!input.value.trim()); }
    input.addEventListener('focus', pokazPodpowiedzi);
    root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.closest('[data-search-desktop-slot]')) { e.preventDefault(); root.classList.remove('szukaj-serwis--otwarta'); }
    });
    document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) root.classList.remove('szukaj-serwis--otwarta');
    });
    function validRow(r){
        if(!r||['title','desc','url','type'].some(function(k){return typeof r[k]!=='string';})||!r.title.trim())return false;
        try{
            var paths=[r.url,decodeURIComponent(r.url)];
            if(paths.some(function(p){return !/^\/(?!\/)/.test(p)||/[\s<>\\{}]/.test(p)||p.includes('..');}))return false;
            var u=new URL(r.url,location.origin);if(u.origin!==location.origin)return false;
            return lang==='en'?u.pathname.startsWith('/en/'):!/^\/(en|de)(\/|$)/.test(u.pathname);
        }catch(e){return false;}
    }
    function norm(v){return String(v||'').toLocaleLowerCase(lang).normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');}
    function index(){
        if(!pending)pending=fetch('/szukaj.php?lang='+lang).then(function(r){if(!r.ok)throw Error('HTTP');return r.json();}).then(function(d){if(!d||d.lang!==lang||!Array.isArray(d.items))throw Error('format');d.items=d.items.filter(validRow);return d;}).catch(function(e){pending=null;throw e;});
        return pending;
    }
    async function search(){
        var id=++seq,q=norm(input.value.trim());pokazPodpowiedzi();list.replaceChildren();
        if(q.length<2){status.textContent=jst("site_search_js.5aa265c73d9e");return;}
        status.textContent=jst("site_search_js.1f3a3a0d462e");
        try{
            var data=await index();if(id!==seq)return;
            var words=q.split(/\s+/),rows=data.items.map(function(r){var title=norm(r.title),text=title+' '+norm(r.desc);return {r:r,score:words.every(function(w){return text.includes(w);})?words.reduce(function(n,w){return n+(title.includes(w)?10:1);},title.includes(q)?20:0):0};}).filter(function(x){return x.score>0;}).sort(function(a,b){return b.score-a.score||a.r.title.localeCompare(b.r.title,lang);});
            var intent = pewniakiSearchIntent(q, data.intentConfig, data.intentRoutes);
            if (intent && validRow(intent)) rows.unshift({r:intent, score:1000});
            status.textContent=(rows.length?jst("site_search_js.09932f0bdf51")+rows.length+(rows.length>30?jst("site_search_js.727ef6ba1dfb"):'.'):jst("site_search_js.78bf07faf1c3"))+(data.partial?jst("site_search_js.aca3eaeb9c4a"):'');
            rows.slice(0,30).forEach(function(x){
                var r=x.r,url=new URL(r.url,location.origin);if(url.origin!==location.origin)return;
                var li=document.createElement('li'),a=document.createElement('a'),p=document.createElement('p');
                a.href=url.pathname+url.search+url.hash;a.textContent=r.title;p.className='tekst-maly';p.textContent=r.type+' — '+r.desc;
                li.append(a,p);list.append(li);
            });
        }catch(e){if(id===seq)status.textContent=jst("site_search_js.af4248e730bc");}
    }
    root.querySelector('[data-search-form]').addEventListener('submit',function(e){e.preventDefault();clearTimeout(timer);search();});
    input.addEventListener('input',function(){++seq;clearTimeout(timer);list.replaceChildren();timer=setTimeout(search,200);});
})();
